<template>
  <div class="col-auto edit-menu">
    <b-dropdown
      variant="link"
      toggle-class="text-dark text-decoration-none overflow-button idea-options-button"
      menu-class="overflow-menu"
      class="idea-options-menu overflow-menu-wrapper"
      :lazy="true"
      no-caret
    >
      <template slot="button-content">
        <i class="overflow-menu-icon"></i>
      </template>
      <b-dropdown-item @click="$emit('open')">
        <action-key action="Open" :key-combination="['Shift', '<right>']" />
      </b-dropdown-item>
      <b-dropdown-item @click="$emit('edit')">
        <action-key action="Edit Idea" :key-combination="['e']" />
      </b-dropdown-item>
      <b-dropdown-item @click="$emit('edit-note')"
        >{{ idea.description ? 'Edit Notes' : 'Add Notes' }}
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="$refs.deleteModal.show()">Delete Idea</b-dropdown-item>
    </b-dropdown>
    <confirm-dialog
      title="Delete this Idea?"
      ref="deleteModal"
      @ok="removeIdea"
      ok-title="Delete idea"
      ok-variant="danger"
    >
      This action cannot be undone.
    </confirm-dialog>
  </div>
</template>

<script>
import * as R from 'ramda'
import { BDropdown, BDropdownItem, BDropdownDivider } from 'bootstrap-vue'
import { DEFAULT_ERROR } from '@/constants/messages'
import { TOAST_TYPE } from '@/constants/toasts'
import EventBus from '@/EventBus'
import ActionKey from '@/components/ActionKey'
import ConfirmDialog from '@/components/ConfirmDialog'
import { mapActions } from 'vuex'

/**
 * This is the component for idea options dropdown
 * props:
 * - idea
 *
 * @emits
 * - open
 * - edit
 * - edit-note
 * - delete-idea
 */
export default {
  name: 'IdeaOptions',
  components: {
    ActionKey,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    ConfirmDialog
  },
  props: ['idea'],
  computed: {
    owners() {
      return this.idea.ownerships.map(x => x.userId)
    }
  },
  methods: {
    ...mapActions('idea', ['deleteIdea']),
    async removeIdea() {
      try {
        await this.deleteIdea({
          orgId: this.idea.organizationId,
          id: this.idea.id
        })
        EventBus.$emit('ADD_TOAST', { message: 'Idea has been deleted successfully' })
        this.$emit('delete-idea', this.idea)
      } catch (e) {
        const message = R.pathOr(DEFAULT_ERROR, ['response', 'data', 'message'], e)
        EventBus.$emit('ADD_TOAST', { message, type: TOAST_TYPE.ERROR })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.edit-menu {
  padding-top: 4px;
}
/deep/ .idea-options-button[aria-expanded='false'] {
  display: none;
}
.idea-options-menu {
  padding-top: 3px;
}
/deep/ .overflow-menu {
  width: 200px;
}
.award-icon {
  @include dimension(20px, 20px);
  background-size: contain;
}
</style>
